import { defineComponent } from "vue";
import { V as VaFileUploadKey } from "../types-8c5c5611.mjs";
import { V as VaButton } from "../../va-button/index-1db585d5.mjs";
import { V as VaListItem, a as VaListItemSection } from "../../va-list/index-d370814a.mjs";
import { u as useTranslation } from "../../../composables/useTranslation-67b81a6e.mjs";
import { u as useStrictInject } from "../../../composables/useStrictInject-08ce5ce6.mjs";
const INJECTION_ERROR_MESSAGE = "The VaFileUploadSingleItem component should be used in the context of VaFileUpload component";
const _sfc_main = defineComponent({
  name: "VaFileUploadSingleItem",
  components: {
    VaButton,
    VaListItem,
    VaListItemSection
  },
  emits: ["remove"],
  props: {
    file: { type: Object, default: null },
    ariaRemoveFileLabel: { type: String, default: "$t:removeFile" }
  },
  setup: () => ({
    ...useTranslation(),
    disabled: useStrictInject(VaFileUploadKey, INJECTION_ERROR_MESSAGE).disabled
  })
});
export {
  _sfc_main as _
};
//# sourceMappingURL=VaFileUploadSingleItem.vue_vue_type_script_lang-de51d58f.mjs.map
